<template>
    <svg xmlns="http://www.w3.org/2000/svg"
         :width="width"
         :height="height"
         :viewBox="'0 ' + '0 ' + ViewWidth.toString() + ' ' + ViewHeight.toString()"
         :aria-labelledby="iconName"
    >
        <title
                :id="iconName"
                lang="en"
        ></title>
    <g>
      <slot />
    </g>
  </svg>
</template>

<script>
    export default {
        props: {
            iconName: {
                type: String,
                default: 'box'
            },
            width: {
                type: [Number, String],
                default: 18
            },
            height: {
                type: [Number, String],
                default: 18
            },
            ViewWidth: {
                type: [Number, String],
                default: 18
            },
            ViewHeight: {
                type: [Number, String],
                default: 18
            },
        }
    }
</script>


